import React from 'react';
import DashboardWorkspaceLayout from './DashboardWorkspaceLayout';
import TrackLineActionModal from './TrackLineActionModal';
import MissionMemberChatWindow from './MissionMemberChatWindow';
import DashboardSendLocationBanner from './DashboardSendLocationBanner';
import DashboardSendLocationComposeModal from './DashboardSendLocationComposeModal';
import DashboardRescueSearchTargetPushModal from './DashboardRescueSearchTargetPushModal';

/** 指挥页已通过口令后的工作区（布局 + 弹窗） */
export default function DashboardAuthedWorkspace({
  layoutProps,
  trackLineActionProps,
  commandFeatures,
  memberChatTarget,
  setMemberChatTarget,
  getMessagesForMember,
  appendMemberMessage,
  placeOutboundCommandPin,
  removeMessageFromMap,
  historyEpoch = 0,
  getMap,
  getBasemapId,
  openLiveStream,
  streamingMembers,
  plantTarget,
  planted,
  isMobile,
  sendingLocation,
  cancelSendLocation,
  confirmSendLocation,
  composeOpen,
  closeSendLocationCompose,
  submitSendLocationCompose,
  members,
  onlineTimeoutMs,
  rescueSearchTargetPushModalProps = null
}) {
  return (
    <>
      <DashboardWorkspaceLayout {...layoutProps} />
      <TrackLineActionModal
        {...trackLineActionProps}
        canDownload={commandFeatures.downloadTrack}
        canExport={commandFeatures.exportTrack}
        canRealtime={commandFeatures.realtimeDraw}
        canView={commandFeatures.viewTrack}
      />
      {commandFeatures.memberCommand && memberChatTarget ? (
        <MissionMemberChatWindow
          member={memberChatTarget}
          messages={getMessagesForMember(memberChatTarget)}
          onClose={() => setMemberChatTarget(null)}
          onOutboundSent={(entry) => {
            appendMemberMessage(entry);
            placeOutboundCommandPin?.(entry);
          }}
          onMessageDeleted={(item) => { removeMessageFromMap?.(item); }}
          getMap={getMap}
          getBasemapId={getBasemapId}
          historyEpoch={historyEpoch}
          isStreaming={!!(streamingMembers && (
            streamingMembers.has?.(memberChatTarget?.name)
            || streamingMembers[memberChatTarget?.name]
          ))}
          onOpenLiveStream={openLiveStream}
        />
      ) : null}
      {!composeOpen && (
        <DashboardSendLocationBanner
          plantTarget={plantTarget}
          planted={planted}
          isMobile={isMobile}
          sendingLocation={sendingLocation}
          onCancel={cancelSendLocation}
          onConfirm={confirmSendLocation}
        />
      )}
      <DashboardSendLocationComposeModal
        open={!!composeOpen}
        planted={planted}
        presetMember={plantTarget}
        members={members}
        onlineTimeoutMs={onlineTimeoutMs}
        sending={sendingLocation}
        onCancel={closeSendLocationCompose}
        onSubmit={submitSendLocationCompose}
      />
      {rescueSearchTargetPushModalProps ? (
        <DashboardRescueSearchTargetPushModal {...rescueSearchTargetPushModalProps} />
      ) : null}
    </>
  );
}
